import { Modal, Space, Table, Tooltip, Input, Popconfirm, InputNumber, Select, Button, Divider, Checkbox } from "antd";
import React from "react";
import { withRouter } from "../../components/withRouter";
import Header from "../../components/Header";
import {
  CheckCircleTwoTone,
  CloseCircleTwoTone,
  SearchOutlined,
  EditOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import { openNotification } from "../../functions";

const { Option } = Select;

class SalerSales extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalRole: false,
      clientName: "",
      selectedRole: "1",
      saleModal: false,

      partners: [],
      products: [],
      clients: [],
      selectedClient: "",
      selectedClientBalans: 0,
      activePromo: "",
      searchProductModal: false,
      searchProdKey: 0,
      searchProdValue: {},
      salesPoints: [],
      sale_products: [
        {
          name: "",
          price: "0",
          count: 1,
        },
      ],
      sum: 0,
      full_sum:0,
      saleSelectSalePoint: 0,
      spheres: [],
      selectedSphere: 1,
      selectedProvider: "",
      sales: [],
      deletebalans: 0,
      deletebalansdel: 0,
      selectedClientBalansDel: 0,
      promocode: false,
      promocodePrice: '0',
      prod_count: 0,

      saleDisc: 0
    };
  }

  ChangeInputValue = (e) => {

    let name = e.target.name;
    let value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
    this.setState({ [name]: value }, () => {
      this.setSum();
    });
  };

  getProducts() {
    fetch(`https://bot.weddingchelny.ru/api/saler/products`, {
      headers: new Headers({
        "Content-Type": "application/json; charset=utf-8",
        Authorization: "Bearer " + localStorage.getItem("ttk"),
      }),
      method: "GET",
    }).then(async (response) => {
      if (response.status == 401) {
        localStorage.clear();
        this.customNavFunction();
      } else {
        let res = await response.json();
        if (res.error) {
          openNotification("Ошибка", res.error, 1, 3.0);
        } else {
          this.setState({ products: res.data });
        }
      }
    });
  }

  getPartners() {
    fetch(`https://bot.weddingchelny.ru/api/saler/partners`, {
      headers: new Headers({
        "Content-Type": "application/json; charset=utf-8",
        Authorization: "Bearer " + localStorage.getItem("ttk"),
      }),
      method: "GET",
    }).then(async (response) => {
      if (response.status == 401) {
        localStorage.clear();
        this.customNavFunction();
      } else {
        let res = await response.json();
        if (res.error) {
          openNotification("Ошибка", res.error, 1, 3.0);
        } else {
          this.setState({ partners: res.data });
        }
      }
    });
  }

  getClients() {
    fetch(`https://bot.weddingchelny.ru/api/saler/clients/allUsers`, {
      headers: new Headers({
        "Content-Type": "application/json; charset=utf-8",
        Authorization: "Bearer " + localStorage.getItem("ttk"),
      }),
      method: "GET",
    }).then(async (response) => {
      if (response.status == 401) {
        localStorage.clear();
        this.customNavFunction();
      } else {
        let res = await response.json();
        if (res.error) {
          openNotification("Ошибка", res.error, 1, 3.0);
        } else {
          this.setState({ clients: res.data });
        }
      }
    });
  }

  addProductOnSale() {
    var sale_products = this.state.sale_products;
    sale_products.push({
      name: "",
      price: "0",
      count: 1,
    });
    this.setState({ sale_products });
  }

  deleteProductOnSale(index) {
    var sale_products = this.state.sale_products;
    sale_products.splice(index, 1);
    this.setState({ sale_products });
    this.setSum();
  }

  newSale() {
    this.getPartners();
    this.getClients();
    this.getPoints();
    this.getSpheres();
    this.setState({
      saleModal: true,
      sale_products: [
        {
          name: "",
          price: "0",
          count: 1,
        },
      ],
      sum: 0,
      saleSelectSalePoint: 0,

      selectedSphere: 1,
      selectedProvider: "",
      deletebalans: 0,
      deletebalansdel: 0,
      selectedClientBalansDel: 0,
      promocode: false,
            promocodePrice: '0',
             full_sum:0,
             prod_count: 0
    });
  }

  onMIChange = (key, e) => {
    let name = e.target.name;
    let val = e.target.type === "checkbox" ? e.target.checked : e.target.value;
    let sale_products = this.state.sale_products;
    sale_products[key][name] = val;
    this.setState({ sale_products });
  };

  ChangeInputPrice = (key, e) => {
    let regex = /^(0|[1-9][0-9]*)(\.[0-9]{0,2})?$/;
    let name = e.target.name;
    let value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
    let sale_products = this.state.sale_products;
    if (regex.test(value) || value == "") {
      sale_products[key][name] = value;
      this.setState({ sale_products });
    }
    this.setSum();
  };

  setSum() {
    let products = this.state.sale_products;
    let sum = 0;
    let full_sum = 0;
    let prod_count = 0;

    products.forEach((element) => {
      sum += Number.parseFloat(element.price).toFixed(2) * Number.parseFloat(element.count).toFixed(2);

      prod_count = Number( prod_count ) + Number(element.count);
      full_sum += Number.parseFloat(element.price).toFixed(2) * Number.parseFloat(element.count).toFixed(2);
    });

    sum = sum - this.state.deletebalans;

    if (this.state.deletebalansdel == true) {
      sum = sum - this.state.selectedClientBalansDel;
    }

    if (this.state.promocode == true) {
      sum = sum - this.state.promocodePrice;
    }

    let sphere = this.state.spheres.find(item => item.id === this.state.selectedSphere);
    if (sphere.sum_ot) {
      if (sum >= sphere.sum_ot) {
        if (sphere.type == 2) {
          sum = sum - sphere.discount;
        } else {
          sum = sum - (sum / 100 * sphere.discount)
        }
      }
    }
  
    let saleDisc = (full_sum - sum) / prod_count;
    this.setState({ sum, full_sum, prod_count, saleDisc });
  }

  searchProduct(index) {
    this.getProducts();
    this.setState({ searchProductModal: true, searchProdKey: index });
  }

  setSelectedProd(elem) {
    let sale_products = this.state.sale_products;
    sale_products[this.state.searchProdKey].name = elem.p_name;
    sale_products[this.state.searchProdKey].price = elem.p_price;
    this.setState({ sale_products, searchProductModal: false, searchProdKey: 0 });
  }

  checkPromo() {
    fetch(`https://bot.weddingchelny.ru/api/saler/sale/checkpromo`, {
      headers: new Headers({
        "Content-Type": "application/json; charset=utf-8",
        Authorization: "Bearer " + localStorage.getItem("ttk"),
      }),
      method: "post",
      body: JSON.stringify({
        promo: this.state.activePromo,
        client: this.state.selectedClient,
      }),
    }).then(async (response) => {
      if (response.status == 401) {
        localStorage.clear();
        this.customNavFunction();
      } else {
        let res = await response.json();
        if (res.error) {
          openNotification("Ошибка", res.error, 1, 3.0);
        } else {
          openNotification("Промокод активирован", res.error, 3, 3.0);
          this.setState({ promocode: true }, () => {
            this.setSum();
          });
        }
      }
    });
  }

  pushSale() {
    fetch(`https://bot.weddingchelny.ru/api/saler/sale/`, {
      headers: new Headers({
        "Content-Type": "application/json; charset=utf-8",
        Authorization: "Bearer " + localStorage.getItem("ttk"),
      }),
      method: "post",
      body: JSON.stringify({
        promo: this.state.activePromo,
        client: this.state.selectedClient,
        products: this.state.sale_products,
        sum: this.state.sum,
        selectPoint: this.state.saleSelectSalePoint,
        sphere: this.state.selectedSphere,
        provider: this.state.selectedProvider,
        deletebalans: Number(this.state.deletebalans),
        deletebalansdel: this.state.deletebalansdel,
      }),
    }).then(async (response) => {
      if (response.status == 401) {
        localStorage.clear();
        this.customNavFunction();
      } else {
        let res = await response.json();
        if (res.error) {
          openNotification("Ошибка", res.error, 1, 3.0);
        } else {
          openNotification("Успех", res.data, 3, 3.0);
          this.setState({
            modalRole: false,
            clientName: "",
            selectedRole: "1",
            saleModal: false,

            partners: [],
            products: [],
            clients: [],
            selectedClient: "",
            selectedClientBalans: 0,
            activePromo: "",
            searchProductModal: false,
            searchProdKey: 0,
            searchProdValue: {},
            salesPoints: [],
            sale_products: [
              {
                name: "",
                price: "",
                count: 1,
              },
            ],

            saleSelectSalePoint: 0,
            spheres: [],
            selectedSphere: 1,
            selectedProvider: "",
            sales: [],
            deletebalans: 0,
            deletebalansdel: 0,
          });
          this.getSales();
        }
      }
    });
  }

  getSales() {
    fetch(`https://bot.weddingchelny.ru/api/saler/sale/all`, {
      headers: new Headers({
        "Content-Type": "application/json; charset=utf-8",
        Authorization: "Bearer " + localStorage.getItem("ttk"),
      }),
      method: "get",
    }).then(async (response) => {
      if (response.status == 401) {
        localStorage.clear();
        this.customNavFunction();
      } else {
        let res = await response.json();
        if (res.error) {
          openNotification("Ошибка", res.error, 1, 3.0);
        } else {
          this.setState({ sales: res.data });
        }
      }
    });
  }

  getSpheres() {
    fetch(`https://bot.weddingchelny.ru/api/saler/spheres`, {
      headers: new Headers({
        "Content-Type": "application/json; charset=utf-8",
        Authorization: "Bearer " + localStorage.getItem("ttk"),
      }),
      method: "get",
    }).then(async (response) => {
      if (response.status == 401) {
        localStorage.clear();
        this.customNavFunction();
      } else {
        let res = await response.json();
        if (res.error) {
          openNotification("Ошибка", res.error, 1, 3.0);
        } else {
          this.setState({ spheres: res.data });
        }
      }
    });
  }

  getPoints() {
    fetch(`https://bot.weddingchelny.ru/api/saler/sales-points`, {
      headers: new Headers({
        "Content-Type": "application/json; charset=utf-8",
        Authorization: "Bearer " + localStorage.getItem("ttk"),
      }),
      method: "GET",
    }).then(async (response) => {
      if (response.status == 401) {
        localStorage.clear();
        this.customNavFunction();
      } else {
        let res = await response.json();
        if (res.error) {
          openNotification("Ошибка", res.error, 1, 3.0);
        } else {
          this.setState({ salesPoints: res.data });
        }
      }
    });
  }

  render() {
    const prodMatrix_columns = [
      {
        title: "Наименование",
        dataIndex: "p_name",
        key: "p_name",
      },
      {
        title: "Цена",
        dataIndex: "p_price",
        key: "p_price",
      },
      {
        title: "",
        dataIndex: "p_select",
        key: "p_select",
        render: (text, record) => {
          return (
            <Button
              type="primary"
              onClick={() => {
                this.setSelectedProd(record);
              }}
            >
              Выбрать
            </Button>
          );
        },
      },
    ];

    const columns = [
      {
        title: "№ продажи",
        dataIndex: "s_id",
        key: "s_id",
      },
      {
        title: "Имя клиента",
        dataIndex: "tgu_name_user",
        key: "tgu_name_user",
      },
      {
        title: "Никнейм Telegram",
        dataIndex: "tgu_username",
        key: "tgu_username",
      },
      {
        title: "Товары",
        dataIndex: "products",
        key: "products",
        render: (text, record) => {
          let str = "";
          record.products.map((elem, index) => {
            str +=
              elem.name + " X " + elem.count + " = " + Number.parseFloat(elem.price * elem.count).toFixed(2) + "; ";
          });
          return str;
        },
      },
      {
        title: "Сумма",
        dataIndex: "full_price",
        key: "full_price",
      },
    ];

    return (
      <div>
        <Header />
        <div className="container">
          <Space>
            <h1>Продажи</h1>
            <Button
              type="primary"
              onClick={() => {
                this.newSale();
              }}
            >
              Новая продажа
            </Button>
          </Space>
          {window.innerWidth > 650 ? (
            <Table columns={columns} dataSource={this.state.sales} />
          ) : (
            this.state.sales.map((elem) => {
              let str = "";
              elem.products.map((el, index) => {
                str += el.name + " X " + el.count + " = " + Number.parseFloat(el.price * el.count).toFixed(2) + "; ";
              });
              return (
                <div className="sale_item">
                  <div>Номер продажи: {elem.s_id}</div>
                  <div>Имя клиента: {elem.tgu_name_user}</div>
                  <div>Telegram клиента: {elem.tgu_username}</div>
                  <div>Товары: {str}</div>
                  <div>Сумма: {elem.full_price}</div>
                </div>
              );
            })
          )}

          <Modal
            style={{ maxWidth: "1200px" }}
            title={"Новая продажа"}
            width={"100%"}
            open={this.state.saleModal}
            onOk={() => {
              // this.checkPromo();
              this.pushSale();
            }}
            onCancel={() => {
              this.setState({ saleModal: false });
            }}
            okText="Сохранить"
            cancelText="Отмена"
          >
            {this.state.sale_products == 0 ? (
              ""
            ) : (
              <div className="products_matrix">
                {this.state.sale_products.map((prod, index) => {
                  return (
                    <div className="prod_container">
                      <div
                        style={{
                          width: 30,
                          justifyContent: "space-between",
                          display: "flex",
                          flexDirection: "column",
                          alignSelf: "auto",
                        }}
                      >
                        {index == 0 ? (
                          ""
                        ) : (
                          <Tooltip title="Удалить позицию">
                            <Button
                              style={{ width: "30px", height: "30px", padding: 0 }}
                              onClick={() => {
                                this.deleteProductOnSale(index);
                              }}
                            >
                              -
                            </Button>
                          </Tooltip>
                        )}
                        {index + 1 == this.state.sale_products.length ? (
                          <Tooltip title="Добавить позицию">
                            <Button
                              style={{ width: "30px", height: "30px", padding: 0 }}
                              onClick={() => {
                                this.addProductOnSale();
                              }}
                            >
                              +
                            </Button>
                          </Tooltip>
                        ) : (
                          ""
                        )}
                      </div>
                      <div key={"sp_" + index} className="prod_elem">
                        <Space style={{ alignItems: "end" }}>
                          <Tooltip title="Найти позицию">
                            <Button
                              onClick={() => {
                                this.searchProduct(index);
                              }}
                            >
                              <SearchOutlined />
                            </Button>
                          </Tooltip>
                          <div>
                            <div>Наименование</div>
                            <Input
                              name="name"
                              onChange={(e) => {
                                this.onMIChange(index, e);
                              }}
                              value={prod.name}
                            />
                          </div>
                          <div>
                            <div>Цена</div>
                            <Input
                              name="price"
                              onChange={(e) => {
                                this.ChangeInputPrice(index, e);
                              }}
                              value={prod.price}
                            />
                          </div>
                          <div>
                            <div>Кол-во</div>
                            <Input
                              type="number"
                              name="count"
                              min="1"
                              onChange={(e) => {
                                this.ChangeInputPrice(index, e);
                              }}
                              value={prod.count}
                            />
                          </div>
                        </Space>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
            <Divider orientation="left">Точка продаж</Divider>
            <Select
              style={{ width: 250 }}
              onChange={(value) => {
                this.setState({ saleSelectSalePoint: value });
              }}
            >
              <Select.Option value="0">Нет</Select.Option>
              {this.state.salesPoints.length > 0
                ? this.state.salesPoints.map((sp, index) => {
                  return (
                    <Select.Option key={"sp_" + index} value={sp.key}>
                      {sp.sp_name}
                    </Select.Option>
                  );
                })
                : ""}
            </Select>
            <Divider orientation="left">Покупатель</Divider>
            <Space direction={window.innerWidth > 650 ? "horizontal" : "vertical"}>
              <div>
                <div>Найти по никнейму</div>
                <Select
                  showSearch
                  value={this.state.selectedClient}
                  placeholder="Выберите фрукт"
                  optionFilterProp="children"
                  filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                  style={{ width: 240 }}
                  onChange={(e) => {
                    this.setState({
                      selectedClient: e,
                      selectedClientBalans: this.state.clients.find((item) => item.key === e).balans,
                      selectedClientBalansDel: this.state.clients.find((item) => item.key === e).burnable_bonuses,
                    });
                  }}
                >
                  {this.state.clients.map((option) => (
                    <Option key={"tg_nick" + option.key} value={option.key}>
                      {option.tgu_username}
                    </Option>
                  ))}
                </Select>
              </div>

              <div>
                <div>Найти по фамилии или имени</div>
                <Select
                  showSearch
                  placeholder="Выберите покупателя"
                  value={this.state.selectedClient}
                  optionFilterProp="children"
                  filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                  style={{ width: 240 }}
                  onChange={(e) => {
                    this.setState({
                      selectedClient: e,
                      selectedClientBalans: this.state.clients.find((item) => item.key === e).balans,
                      selectedClientBalansDel: this.state.clients.find((item) => item.key === e).burnable_bonuses,
                    });
                  }}
                >
                  {this.state.clients.map((option) => (
                    <Option key={"th_name" + option.key} value={option.key}>
                      {option.tgu_name_user}
                    </Option>
                  ))}
                </Select>
              </div>
            </Space>
            <Divider orientation="left">Снять с баланса</Divider>
            <Space direction={window.innerWidth > 650 ? "horizontal" : "vertical"}>
              <div>
                <div>Доступно постоянных бонусов: {this.state.selectedClientBalans} </div>
                <InputNumber min={0}
                  max={this.state.selectedClientBalans}
                  name="deletebalans"
                  value={this.state.deletebalans}
                  onChange={(e) => {
                    this.setState({ deletebalans: e }, () => {
                      this.setSum();
                    });
                  }}
                />
              </div>
              <div style={{ marginLeft: window.innerWidth > 650 ? 30 : 0 }}>
                <div>Доступно сгорающих бонусов: {this.state.selectedClientBalansDel} </div> Снять?{" "}
                <Checkbox
                  onChange={(e) => {
                    this.setState({ deletebalansdel: e.target.checked }, () => {
                      this.setSum();
                    });
                  }}
                  checked={this.state.deletebalansdel}
                ></Checkbox>
              </div>
            </Space>
            <Space></Space>
            <Divider orientation="left">Промокод</Divider>
            <Space>
              <Input name="activePromo" value={this.state.activePromo} onChange={this.ChangeInputValue.bind(this)} />
              <Button onClick={() => { this.checkPromo(); }}>Использовать</Button>

              {
                this.state.promocode == true ?
                <Input name="promocodePrice" value={this.state.promocodePrice} onChange={this.ChangeInputValue.bind(this)} />
                :
                ""
              }
            </Space>

            <Divider orientation="left">Сфера</Divider>
            <div>
              <div>Выберите сферу</div>
              <Select
                showSearch
                placeholder="Выберите сферу"
                value={this.state.selectedSphere}
                optionFilterProp="children"
                filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                style={{ width: 540 }}
                onChange={(e) => {
                  this.setState({ selectedSphere: e }, () => {
                    this.setSum();
                  });
                }}
              >
                {this.state.spheres.map((option) => (
                  <Option key={"th_name" + option.id} value={option.id}>
                    {option.name} {option.discount}
                    {option.type == 1 ? "%" : "руб."}
                  </Option>
                ))}
              </Select>
            </div>
            <Divider orientation="left">Кто привел покупателя</Divider>
            <Space direction={window.innerWidth > 650 ? "horizontal" : "vertical"}>
              <div>
                <div>Найти по никнейму</div>
                <Select
                  showSearch
                  value={this.state.selectedProvider}
                  placeholder="Выберите фрукт"
                  optionFilterProp="children"
                  filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                  style={{ width: 240 }}
                  onChange={(e) => {
                    this.setState({ selectedProvider: e });
                  }}
                >
                  {this.state.clients.map((option) => (
                    <Option key={"tg_nick" + option.key} value={option.key}>
                      {option.tgu_username}
                    </Option>
                  ))}
                </Select>
              </div>

              <div>
                <div>Найти по фамилии или имени</div>
                <Select
                  showSearch
                  placeholder="Выберите покупателя"
                  value={this.state.selectedProvider}
                  optionFilterProp="children"
                  filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                  style={{ width: 240 }}
                  onChange={(e) => {
                    this.setState({ selectedProvider: e });
                  }}
                >
                  {this.state.clients.map((option) => (
                    <Option key={"th_name" + option.key} value={option.key}>
                      {option.tgu_name_user}
                    </Option>
                  ))}
                </Select>
              </div>
            </Space>
            <Divider orientation="left">Итого: {this.state.sum}</Divider>
            <Divider orientation="left">Список цен со скидкой</Divider>
            {this.state.sale_products.map((el, index) => {
              return <div key={"sdfs_"+index}>
                {el.name} X 1 = {Number.parseFloat(el.price).toFixed(2) - (Number.parseFloat(this.state.saleDisc).toFixed(2)/Number.parseFloat(el.count).toFixed(2)) == 0 ? el.price : Number.parseFloat(Number.parseFloat(el.price).toFixed(2) - (Number.parseFloat(this.state.saleDisc).toFixed(2)/Number.parseFloat(el.count).toFixed(2))).toFixed(2)}
              </div>
            })}
          </Modal>
          <Modal
            style={{ maxWidth: "1200px" }}
            title={"Выберите позицию"}
            width={"100%"}
            open={this.state.searchProductModal}
            onCancel={() => {
              this.setState({ searchProductModal: false, searchProdKey: 0 });
            }}
            footer={[]}
          >
            <Table columns={prodMatrix_columns} dataSource={this.state.products} />
          </Modal>
        </div>
      </div>
    );
  }

  componentDidMount() {
    this.getSales();
  }
}

export default withRouter(SalerSales);
